import { useMemo } from 'react';
import { defineBlock, useEditor, smartProps, BlockWrapper, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableImg, EditableText } from '@smartfire/components';
import Inspector from './inspector';
import style from './style.module.scss';
import Arrow from '../../assets/icons/arrow_right';

function Block({ linkType, link, targetBlank }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    const href = useMemo(() => {
        switch (linkType) {
            case 'email':
                return 'mailto:' + link;
            case 'tel':
                return 'tel:' + link;
            default:
                return link;
        }
    }, [link, linkType]);

    return (
        <BlockWrapper.A
            className={style.block}
            href={!isEditing && href ? href : undefined}
            target={targetBlank ? '_blank' : undefined}
            download={linkType === 'file'}
        >
            <div>
                <EditableImg smartProp="image" />
                <div className={style.filter} />
            </div>
            <EditableText tagName="p" smartProp="text" placeholder="Titre..." />
            <span>
                <EditableText tagName="p" smartProp="text2" placeholder="En savoir plus..." />
                <Arrow />
            </span>
        </BlockWrapper.A>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.image,
        text: smartProps.string.withDefault(''),
        text2: smartProps.string.withDefault(''),
        linkType: smartProps.string.withDefault('page'),
        link: smartProps.string.withDefault(''),
        postType: smartProps.string.withDefault(''),
        postId: smartProps.number.withDefault(0),
        taxonomy: smartProps.string.withDefault(''),
        termId: smartProps.number.withDefault(0),
        fileId: smartProps.number.withDefault(0),
        targetBlank: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Tile',
        parent: ['smartfire/home-menu'],
    },
});
